export default __webpack_public_path__ + "static/media/globo.e85ad345.svg";